import React from 'react';
import { Controller } from 'react-hook-form';
import _get from 'lodash/get';

import AssetUpload, { AssetType } from '../baseui/input/assetUpload';

interface AssetUploadInput2Props {
	name: any;
	assetType: AssetType;
	control: any;
	setShowLoader: any;
	defaultValue: any;
	downloadFile?: boolean;
	link?: string;
	displayText?: string;
	label?: string;
}

const AssetUploadInput2: React.FC<AssetUploadInput2Props> = (props) => {
	const { name, assetType, control, setShowLoader, defaultValue } = props;
	return (
		<Controller
			render={({ field: { onChange, value } }) => (
				<AssetUpload {...props} assetType={assetType} onChange={onChange} value={value} setShowLoader={setShowLoader} />
			)}
			control={control}
			name={name}
			defaultValue={defaultValue && _get(defaultValue, ['field', ...defaultValue.path])}
		/>
	);
};

export default AssetUploadInput2;
